document.addEventListener('DOMContentLoaded', function () {
  // Mobile toggle
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.bh-menu-toggle');
    if (!btn) return;
    const root = btn.closest('.bh-collection-layout') || document.body;
    const isOpen = root.classList.toggle('bh-menu--open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  const arbo = window.menuBhData;
  if (!arbo) return;

  // L'arbre est indexé par id ; on construit un index par handle
  // (la page fournit collection.handle dans #collection_select, identique entre stores).
  const byHandle = {};
  for (const k in arbo) {
    if (arbo[k] && arbo[k].handle) byHandle[arbo[k].handle] = arbo[k];
  }

  const colInput = document.getElementById('collection_select');
  if (!colInput) return;
  const colHandle = colInput.value;

  const entry = byHandle[colHandle];
  if (!entry) return;

  // Walk parent chain (root first)
  function getParents(start) {
    const chain = [];
    let cur = start;
    while (cur && cur.parent && cur.parent.handle) {
      const p = byHandle[cur.parent.handle];
      if (!p) break;
      chain.unshift(p);
      cur = p;
    }
    return chain;
  }

  function esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  const parents = getParents(entry);

  const children = (entry.childs || [])
    .map(function (c) { return byHandle[c.handle] || c; })
    .filter(function (c) { return c && c.display !== false; })
    .sort(function (a, b) {
      return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : a.title.toLowerCase() > b.title.toLowerCase() ? 1 : 0;
    });

  let html = '<dl><div id="bh_menu_title">Catégories</div>';

  parents.forEach(function (p) {
    if (!p || p.display === false) return;
    if (p.noLink) {
      html += '<dt><span>&#8249; ' + esc(p.title) + '</span></dt>';
    } else {
      html += '<dt><a href="/collections/' + esc(p.handle) + '">&#8249; ' + esc(p.title) + '</a></dt>';
    }
  });

  html += '<dd><h4><a href="/collections/' + esc(entry.handle) + '">' + esc(entry.title) + '</a></h4>';

  if (children.length) {
    html += '<ul>';
    children.forEach(function (child) {
      if (child.noLink) {
        html += '<li><span class="noLink">' + esc(child.title) + '</span></li>';
      } else {
        html += '<li><a href="/collections/' + esc(child.handle) + '">' + esc(child.title) + '</a></li>';
      }
    });
    html += '</ul>';
  }

  html += '</dd></dl>';

  const menuEl = document.getElementById('bh_menu');
  if (menuEl) menuEl.innerHTML = html;

  // Scroll: adjust top/bottom for fixed sidebar
  window.addEventListener('scroll', function () {
    if (!menuEl) return;
    if (window.getComputedStyle(menuEl).position !== 'fixed') {
      menuEl.style.top = '0px';
      return;
    }
    const scrollTop = window.scrollY;
    const topMax = 115, topMin = 65;
    const newTop = Math.max(topMin, Math.min(topMax, topMax - scrollTop));
    menuEl.style.top = newTop + 'px';

    const newsletter = document.querySelector('.newsletter');
    if (newsletter) {
      const newsletterTop = newsletter.getBoundingClientRect().top + scrollTop - window.innerHeight;
      const diff = scrollTop - newsletterTop;
      menuEl.style.bottom = diff > 0 ? Math.round(diff) + 'px' : '0px';
    }
  });
});
